//引入外部模組
import 'pannellum';
import 'pannellum/build/pannellum.css';
import {checkDevice} from '@/common';




//VR 720
class VR720 {
  constructor() {
    this.document        = $(document);
    this.vr              = $('#vr720');
    this.data            = this.vr.data('vr-json');
    this.view            = 'VRView';
    this.vrBannerTitle   = this.vr.find('.vrTitleBox');
    this.vrExperienceBtn = this.vrBannerTitle.find('.vrTitle button');
    this.controlBtns     = this.vr.find('.controlBtns button');
    this.mapBox          = this.vr.find('.vrMapBtns');
    this.mapBtnClose     = this.mapBox.find('.header')
    this.mapBtns         = this.mapBox.find('li button');
  }
  //VR 視圖
  vrView() {
    $.getJSON(this.data, (json) => {
      //控制項目
      //https://github.com/mpetroff/pannellum/blob/master/doc/json-config-parameters.md
      let vrData = {
        "default": {
          'type'                     : 'equirectangular', //觀看模式
          'mouseZoom'                : 'fullscreenonly',  //滑鼠滾輪放大縮小
          'showControls'             : false,             //工具列(全螢幕 + 放大縮小)
          'autoLoad'                 : false,              //是否一開始載入圖片，無須點擊
          'autoRotate'               : 0,                //自動旋轉
          'autoRotateInactivityDelay': 5000,              //事件後再次自動選轉
          'compass'                  : true,              //開啟關閉指南針
          'firstScene'               : 'vr0',             //一開始預設場景圖片
          'sceneFadeDuration'        : 1000,              //切換圖片淡出淡入效果
          'orientationOnByDefault'   : false              //開啟關閉陀螺儀
        },
        "scenes": {}
      };
      vrData.scenes = json;
      let viewer = pannellum.viewer(this.view, vrData);

      //控制選項
      this.controlBtns.each((i, e) => {
        //全螢幕
        $(e).on('click', () => {
          if($(e).is('.fullScreen')){
            viewer.toggleFullscreen();
          }
        });
        document.addEventListener('fullscreenchange', () => {
          if(document.fullscreenElement){
            if($(e).is('.fullScreen')){
              $(e).addClass('active');
            }
            this.vrBannerTitle.addClass('active');
          }else{
            if($(e).is('.fullScreen')){
              $(e).removeClass('active');
            }
            this.vrBannerTitle.removeClass('active');
          }
        });
        document.addEventListener('webkitfullscreenchange', () => {
          if(document.webkitFullscreenElement){
            if($(e).is('.fullScreen')){
              $(e).addClass('active');
            }
            this.vrBannerTitle.addClass('active');
          }else{
            if($(e).is('.fullScreen')){
              $(e).removeClass('active');
            }
            this.vrBannerTitle.removeClass('active');
          }
        });
        document.addEventListener('mozfullscreenchange', () => {
          if(document.mozFullScreenElement){
            if($(e).is('.fullScreen')){
              $(e).addClass('active');
            }
            this.vrBannerTitle.addClass('active');
          }else{
            if($(e).is('.fullScreen')){
              $(e).removeClass('active');
            }
            this.vrBannerTitle.removeClass('active');
          }
        });
        document.addEventListener('MSFullscreenChange', () => {
          if(document.msFullscreenElement){
            if($(e).is('.fullScreen')){
              $(e).addClass('active');
            }
            this.vrBannerTitle.addClass('active');
          }else{
            if($(e).is('.fullScreen')){
              $(e).removeClass('active');
            }
            this.vrBannerTitle.removeClass('active');
          }
        });

        /*使用HTML5與原生JS方式執行
        const view = document.getElementById(this.view);
        //開啟全螢幕
        if(view.requestFullscreen) {
          view.requestFullscreen();
        }else if(view.webkitRequestFullscreen){
          view.webkitRequestFullscreen();
        }else if(view.mozRequestFullScreen){
          view.mozRequestFullScreen();
        }else if(view.msRequestFullscreen){
          view.msRequestFullscreen();
        }
        //關閉全螢幕
        if(document.fullscreenElement){
          document.exitFullscreen();
        }else if(document.webkitFullscreenElement){
          document.webkitExitFullscreen();
        }else if(document.mozFullScreenElement){
          document.mozCancelFullScreen();
        }else if(document.msFullscreenElement){
          document.msExitFullscreen();
        }
        */

        //判斷行動裝置，是否隱藏顯示
        if(checkDevice.ios || checkDevice.android){
          $(e).on('click', () => {
            if($(e).is('.zoomIn')){
              //Animation true開啟，陀螺儀縮放失效，需false關掉才可以做縮放。
              viewer.setHfov(viewer.getHfov() - 10, false);
            }else if($(e).is('.zoomOut')){
              //Animation true開啟，陀螺儀縮放失效，需false關掉才可以做縮放。
              viewer.setHfov(viewer.getHfov() + 10, false);
            }else if($(e).is('.experience')){
              $(e).toggleClass('active');
              if($(e).is('.active')){
                //開啟陀螺儀
                viewer.startOrientation();
              }else{
                //關閉陀螺儀
                viewer.stopOrientation();
              }
            }
          });
          //顯示陀螺儀按鈕
          if($(e).is('.experience')){
            $(e).parent().show();
          }
          //組件未支援陀螺儀模式可滑動螢幕，會直接關閉陀螺儀模式變為一般模式，以下為追加
          viewer.on('touchstart', () => {
            if($(e).is('.experience')){
              $(e).removeClass('active');
              viewer.stopOrientation();
            }
          });
          //立即體驗
          this.vrExperienceBtn.on('click', () => {
            this.vrBannerTitle.addClass('active');
          });
        }else{
          $(e).on('click', () => {
            if($(e).is('.zoomIn')){
              viewer.setHfov(viewer.getHfov() - 10);
            }else if($(e).is('.zoomOut')){
              viewer.setHfov(viewer.getHfov() + 10);
            }
          });
          //隱藏陀螺儀按鈕
          if($(e).is('.experience')){
            $(e).parent().hide();
          }
          //立即體驗
          this.vrExperienceBtn.on('click', () => {
            if($(e).is('.fullScreen')){
              $(e).toggleClass('active');
              viewer.toggleFullscreen();
            }
          });
        }
        //iOS裝置隱藏全螢幕(iOS不支援全螢幕)
        if(checkDevice.ios){
          if($(e).is('.fullScreen')){
            $(e).parent().hide();
          }
        }
      });
      //Tabs 按鈕切換
      this.mapBtns.each((i, e) => {
        $(e).on('click', () => {
          this.mapBtns.removeClass('active');
          $(e).addClass('active');
          viewer.loadScene('vr' + i);
          this.mapBox.removeClass('active');
        });
      });
      //Tabs 按鈕切換 (Hot Spots)
      viewer.on('load', () => {
        this.mapBtns.each((i, e) => {
          if(viewer.getScene() == 'vr' + i){
            this.mapBtns.removeClass('active');
            $(e).addClass('active');
          }
        });
      });
    });
  }
  //VR 按鈕地圖
  vrMap() {
    //開啟
    this.controlBtns.on('click', (e) => {
      const $this = $(e.currentTarget);
      if($this.is('.map')){
        this.mapBox.addClass('active');
      }
    });
    //關閉
    this.mapBtnClose.on('click', () => {
      this.mapBox.removeClass('active');
    });
  }
  //整合
  vr720() {
    this.vrView();
    this.vrMap();
  }
}




//輸出
export {VR720};


// WEBPACK FOOTER //
// ./js_new/vr720.js